import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    fallbackPath: { type: String, default: "/" },
  };

  navigate() {
    // > 2 because opening a new tab and then entering a bad url (e.g. a copy & paste) count as 2
    if (history.length > 2) {
      history.back();
    } else {
      window.location.href = this.fallbackPathValue;
    }
  }
}
